// extracted by mini-css-extract-plugin
export default {"menu":"MapMenu_menu__c9LnT","m1":"MapMenu_m1__yZhVD","m2":"MapMenu_m2__dXzBv","btn":"MapMenu_btn__whVKl"};